let loadedScripts = {};

// Utility to dynamically fetch an external javascript
// Returns a promise which will be resolved once the script is loaded
// Options:
//   unless: bool set to true if script is already loaded (i.e. we want to load Stripe's script unless window.Stripe is already defined: requireScriot(url, {condition: window.Stripe})
export default function(url, {unless}={}) {
  if (unless) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    if(!loadedScripts[url]) {
      const scriptId = `async_loaded_script_${Math.trunc(Math.random() * 1000)}`;

      loadedScripts[url] = scriptId;

      var head = document.getElementsByTagName('head')[0];

      var script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.src = url;
      script.type = 'text/javascript';

      head.appendChild(script);
    }

    document.querySelector(`#${loadedScripts[url]}`).addEventListener('load', resolve);
  });
}